import type { PaginationState } from '@tanstack/react-table'
import { useUnit } from 'effector-react'
import type { DateRange } from 'react-day-picker'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { ppvTrackingService } from '@/modules/tracking/ppv/service/ppv-tracking-service.ts'

interface UseMessageQuery {
  date: DateRange | undefined
  categoryIndex: string
  mediaSetIndex: string
  pagination: PaginationState
}

export const usePpvTrackingMessagesQuery = ({
  date,
  categoryIndex,
  mediaSetIndex,
  pagination,
}: UseMessageQuery) => {
  const creatorId = useUnit($creatorId)

  return useQuery(
    [
      'ppvTrackingMessages',
      date?.from,
      date?.to,
      categoryIndex,
      mediaSetIndex,
      pagination.pageSize,
      pagination.pageIndex,
    ],
    () => {
      return ppvTrackingService.getPpvTrackingMessages({
        creatorId: creatorId!,
        from: date!.from!,
        to: date!.to!,
        categoryIndex: parseInt(categoryIndex),
        mediaSetIndex: mediaSetIndex,
        limit: pagination.pageSize,
        page: pagination.pageIndex,
      })
    },
    {
      enabled: !!(date?.from && date?.to && creatorId),
    },
  )
}
